// extracted by mini-css-extract-plugin
export default {"inputs":"ModalActions_inputs__hJEsO","column":"ModalActions_column__E1+2Q","column-sm":"ModalActions_column-sm__DI4+9"};